/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import eventDispatcher from '../events/dispatch';

const firebaseProxyUrl =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8080/api/v1/firebaseServiceProxy'
    : '/api/v1/firebaseServiceProxy';

const s4 = () =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);

export default {
  guid() {
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  },
  shortRandomId() {
    return s4() + s4();
  },
  isEmptyObject(obj) {
    for (const prop in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }

    return JSON.stringify(obj) === JSON.stringify({});
  },
  sortArrayByKey(array, key) {
    return array.sort(function(a, b) {
      const x = b[key].toLowerCase();
      const y = a[key].toLowerCase();

      return x > y ? -1 : x < y ? 1 : 0;
    });
  },
  isProduction() {
    // return process.env.PLATFORM_ENV === 'prod'
    return window.location.hostname === 'platform.mikmak.tv';
  },
  isPreviewChannel() {
    return /^mikmak-platform-development--[a-zA-Z0-9.-]*-[a-zA-Z0-9]{8}.web.app/.test(
      window.location.hostname,
    );
  },
  isDev() {
    return window.location.hostname === 'platform-dev.mikmak.tv';
  },
  getQueryParam(searchKey) {
    let match;
    let queryParams = window.location.search;

    if (queryParams && queryParams[0] == '?') {
      queryParams = queryParams.substring(1);

      const pairArray = queryParams.split('&');

      pairArray.map(pair => {
        const key = pair.split('=')[0];
        const value = pair.split('=')[1];

        if (key == searchKey) {
          match = value;
        }
      });
    }

    return match;
  },
  numberWithCommas(x) {
    const parts = x.toString().split('.');

    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
      (parts[1] ? '.' + parts[1] : '')
    );
  },
  stringToTitleCase(str = '') {
    return str.split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  },
  isLocalHost() {
    return window.location.host.search('localhost') >= 0;
  },
  /** this generateEventAPIUrl method is checking if env variables are present to directly hit api without cloud proxy service
   * */
  generateEventAPIUrl(productionURL) {
    const eventApiPreviewUrl = process.env.VUE_APP_EVENT_API_URL;

    return eventApiPreviewUrl ? eventApiPreviewUrl
      : `https://${window.location.hostname}/${productionURL}`;
  },
  shouldBypassCloudProxy(isEventApi = false) {
    const isCloudProxyEnabled = process.env.VUE_APP_IS_CLOUD_PROXY_ENABLE;

    return isCloudProxyEnabled === 'false' && isEventApi;
  },
  async getFromMikMakFirebaseService(path, token) {
    const response = await $.ajax({
      url: `${firebaseProxyUrl}/${path}`,
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      type: 'GET',
      success: function() { },
      error: function(xhr, desc, err) {
        eventDispatcher('getFromFirebaseServiceError', {
          xhr,
          desc,
          err,
          path,
        });
      },
    });

    return response;
  },
  getEnvironmentName() {
    switch (true) {
      case this.isPreviewChannel():
        return 'preview';
      case this.isDev():
        return 'development';
      case this.isProduction():
        return 'production';
      case this.isLocalHost():
        return 'local';
      default:
        return undefined;
    }
  },
  arraysMatchWithWildcard(arr1, arr2, wildcard) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    return arr1.every((value, index) => {
      if (value.startsWith(wildcard) || arr2[index].startsWith(wildcard)) return true;

      return value === arr2[index];
    });
  },
  validateEmail(string) {
    // eslint-disable-next-line max-len
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // Email validation Regex source: http://emailregex.com/

    return regex.test(string);
  },
};
